import React from 'react'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
import { dismissPopover } from 'services/OverlayService'
import ConfirmModalDialogContainer from 'redux/containers/components/shared/ConfirmModalDialogContainer'

const theme = createMuiTheme({ palette: { primary: { main: '#004b7a' } } })

const ConfirmModal = (props) => (
  <MuiThemeProvider theme={theme}>
    <div
      onClick={(e) => {
        dismissPopover(e.target)
        e.stopPropagation()
      }}
    >
      <ConfirmModalDialogContainer {...props} />
    </div>
  </MuiThemeProvider>
)

ConfirmModal.disableOutsideToggle = true

export default ConfirmModal
